import React, { Component } from 'react'
import CSSModules from 'react-css-modules'
import config from '../../config'
import { Link } from '../../components'
import Styles from './FooterPartner.css'

@CSSModules(Styles)
export default class FooterPartner extends Component {
  constructor(props){
    super(props)
  }
  render() {
    return (
      <div styleName='logo-second-wrap'>
        <Link
          to={config.routes.home}
          title='Fossil Free Funds'>
          <div styleName='footer-donate-headline'>
            Fossil Free Funds
          </div>
        </Link>
        <div styleName='footer-donate-tagline'>
          See the climate risk of mutual funds<br/>from your retirement plan or portfolio
        </div>
        <div styleName='footer-social-icons-item'>
          <Link
            to={config.links.socialFFFfb}
            title='Fossil Free Funds Facebook'>
            <i styleName='footer-social-icon' className='fa fa-facebook-official'/>
          </Link>
          <Link
            to={config.links.socialFFFtwitter}
            title='Fossil Free Funds Twitter'>
            <i styleName='footer-social-icon' className='fa fa-twitter'/>
          </Link>
        </div>
      </div>
    )
  }
}
